﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class KWSessionvar extends TKCustomElementFactory {
    inputs: NodeListOf<HTMLInputElement>;
    oc?: string;

    constructor() {
        super();

        this.oc = this.getAttribute('data-tk-url') || undefined;
        this.inputs = this.querySelectorAll('[data-tk-var-key]') || undefined;
    }

    connectedCallback(): void {
        if (this.inputs.length === 0 || !this.oc) return;

        this.registerListener();
    }

    registerListener(): void {
        [...this.inputs].forEach((input) => {
            const action = this.sendRequest.bind(this, input);

            this.pushListener({
                event: 'focusout',
                element: input,
                action,
            });
        });
    }

    sendRequest(input: HTMLInputElement) {
        if (input.value === '' && input.getAttribute('data-tk-var-key') === '') return;

        const data = {
            key: (input.getAttribute('data-tk-var-key') || `KWSessionvar ${Date.now()}`),
            value: input.value,
        };

        fetchRequest({
            requestURL: this.oc!,
            resolveHandler: () => {},
            payload: data,
        });
    }
}